import { GameManager } from './types';
import { resetButtonStates } from './input';

export let lastHideTime = 0;

export function onBlur() {
  resetButtonStates();
}

export function onFocus(manager: GameManager) {
  manager.space.isDirty = true;
  manager.cursor.focussedThisMouseDown = true;
}

export function onVisibilityChanged() {
  if (document.hidden) {
    lastHideTime = Date.now();
  } else {
    const diffMilis = Date.now() - lastHideTime;
    const diffMinutes = diffMilis / 1000 / 60;

    if (diffMinutes > 120) {
      location.reload();
    }
  }
}

export function showMouseCursor(manager: GameManager) {
  manager.DOM.canvasElement.style.cursor = 'default';
}

export function setMouseCursor(cursor: string) {
  document.body.style.cursor = cursor;
}

export function resetMouseCursor() {
  setMouseCursor("url('images/cursor2.svg') 2 0, auto");
}
